import React, { Component } from 'react';
import { UNUPGRADED_AMENITY_IDS, UNUPGRADED_FACTION_BED_IDS, UNUPGRADED_LODGING_IDS } from '../Common/CardUtilities';
import { getAmenityTextureUrl, getBedTextureUrl, getFactionActionTextureUrl, getLodgingTextureUrl } from '../Common/TextureTools';

import './pools.css';


class PoolTypeIcon extends Component {
    render() {
        let textureUrl;
        let itemId = this.props.itemId;
        textureUrl = this.props.poolIconFunction(itemId);
        return <div id={'pool-item'}>
            <img
                src={textureUrl}
                alt="pool-type"
                style={{ width: '120px' }}
            />
        </div>;
    }
}

export default class GamePlayerPools2d extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        let gamePlayerData = this.props.gamePlayerData;
        if (!gamePlayerData) {
            return <></>;
        }
        // let bedPool = gamePlayerData.bed_pool;
        // let pool0 = bedPool[0].filter(Number.isInteger);
        // let pools = gamePlayerData.pools;

        const poolIconFunctions = [
            getFactionActionTextureUrl,
            getAmenityTextureUrl,
            getBedTextureUrl,
            getLodgingTextureUrl
        ];

        let pools = {
            action: [ 0, 0, 0, 0, 0, 0 ],
            amenity: [ 0, 0, 0, 0, 0, 0 ],
            bed: [ 0, 0, 0, 0, 0, 0 ],
            lodging: [ 0, 0, 0, 0, 0, 0 ],
        }

        let possible_amenities = UNUPGRADED_AMENITY_IDS;
        let possible_beds = UNUPGRADED_FACTION_BED_IDS;
        let possible_lodgings = UNUPGRADED_LODGING_IDS;

        let game = this.props.gameData;
        let action_pool = game.action_pool
        let amenity_pool = game.amenity_pool
        let bed_pool = game.bed_pool
        let lodging_pool = game.lodging_pool
        action_pool.forEach((action, i) => {
            if (action) pools.action[i] = 1
        })
        amenity_pool.forEach((stack, i) => {
            let room_id = possible_amenities[i];
            if (stack.includes(room_id)) {
                pools.amenity[i] = stack.filter(roomId => roomId===room_id).length
            }
        })
        bed_pool.forEach((stack, i) => {
            let room_id = possible_beds[i];
            if (stack.includes(room_id)) {
                pools.bed[i] = stack.filter(roomId => roomId===room_id).length
            }
        })
        lodging_pool.forEach((stack, i) => {
            let room_id = possible_lodgings[i];
            if (stack.includes(room_id)) {
                pools.lodging[i] = stack.filter(roomId => roomId===room_id).length
            }
        })


        return (<div className={'pool-root-container'}>
            <div className={'pool-root'} id={'game-pools-2d'}>
                <div className={'pool-root-flex'}>
                    {Object.entries(pools).map(([ poolKey, pool ], poolKeyIndex) => {
                        return <div className={`pool-${poolKeyIndex}`}
                                    key={`pool-${poolKeyIndex}`}
                                    id={`pool-${poolKey}`}>
                            <div className={`pool-anchor-0`} key={`pool-anchor-${poolKeyIndex}`}>
                                <div className={`pool-anchor-adjustment`}>
                                    {pool.map((count, poolIndex) => {
                                        return <div className={`pools-container-${poolIndex}`}
                                                    id={`bed-pool-${poolIndex}`}
                                                    key={`poolIndex-${poolIndex}`}
                                        >
                                            <PoolTypeIcon
                                                itemId={poolIndex + 1} {...this.props}
                                                poolIconFunction={poolIconFunctions[poolKeyIndex]}
                                            />
                                            <div className={'pools-anchor'}>
                                                <div className={'pool-container'}>
                                                    {new Array(count).fill(true).map((foo, index) => {
                                                        return <div
                                                            className={`segment-container rotate-segment-${index}`}
                                                            key={index}>
                                                            <div className="tr segment"/>
                                                        </div>;
                                                    })}
                                                </div>
                                            </div>
                                        </div>;
                                    })}
                                </div>
                            </div>
                        </div>;
                    })}
                </div>
            </div>
        </div>);
    }
}
